import { useState, useEffect } from "react";
import { supabase } from "../auth/supabaseClient";
import { useParams } from "react-router-dom";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import moment from "moment";
import { ethers } from "ethers";

export default function PublicAward() {
  const [loading, setLoading] = useState(true);
  const [award, setAward] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetchAward();
  }, []);

  async function fetchAward() {
    let { data, error } = await supabase
      .from("awards")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      console.log("error", error);
    } else {
      setAward(data);
      setLoading(false);
      console.log("award data", data);
    }
  }

  if (loading) {
    return (
      <div className="grid place-items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    );
  }

  return (
    <div class="flex h-screen bg-slate-200">
      <div class="m-auto px-10">
        <PublicAwardCard award={award} />
      </div>
    </div>
  );
}

function PublicAwardCard(props) {
  const [identityString, setIdentityString] = useState("");
  const [profileImageUrl, setProfileImageUrl] = useState(
    "https://ribbon-public-assets.s3.amazonaws.com/temp-image.png"
  );

  useEffect(() => {
    if (props.award) {
      getIdentity();
    }
  }, [props.award]);

  const downloadProfileImage = async (photoUrl) => {
    try {
      const { data, error } = await supabase.storage
        .from("avatars")
        .download(photoUrl);
      if (error) {
        throw error;
      }
      const url = URL.createObjectURL(data);
      setProfileImageUrl(url);
    } catch (error) {
      console.log("Error downloading image: ", error.message);
    }
  };

  async function getIdentity() {
    // look up and return profile associated with eth address
    if (props.award.eth_address) {
      console.log("hit");
      const { data: addressData, error: addressError } = await supabase
        .from("addresses")
        .select("*")
        .eq("address", props.award.eth_address)
        .single();

      if (addressData) {
        const { data: profileData } = await supabase
          .from("profiles")
          .select("*")
          .eq("id", addressData.user_id)
          .single();

        if (profileData) {
          console.log("before", profileData);
          setIdentityString(
            profileData.first_name + " " + profileData.last_name
          );
          downloadProfileImage(profileData.photo_url);
        }
      } else {
        // resolve ETH address to ENS name
        const provider = new ethers.providers.JsonRpcProvider(
          process.env.REACT_APP_ALCHEMY_RPC_URL
        );
        let resolvedEns = await provider.lookupAddress(props.award.eth_address);

        if (resolvedEns) {
          setIdentityString(resolvedEns);
        } else {
          // first and last part of eth address
          let ethAddress = props.award.eth_address;
          let ethAddressDisplay =
            ethAddress.substring(0, 5) + "..." + ethAddress.substring(38);
          setIdentityString(ethAddressDisplay);
        }
      }
    } else if (props.award.email) {
      // this is incomplete
      // we need to look up the profile associated with the email
      setIdentityString(props.award.email);
    }
  }

  return (
    <div className="max-w-md min-w-md w-100 px-4 py-4 bg-white shadow-md rounded-lg">
      <div className="py-2 flex flex-row items-center justify-between">
        <div className="flex flex-row items-center">
          <a
            href="#"
            className="flex flex-row items-center focus:outline-none focus:shadow-outline rounded-lg"
          >
            <img
              className="rounded-full h-8 w-8 object-cover"
              src={profileImageUrl}
              alt=""
            />
            <p className="ml-2 text-base font-medium">{identityString}</p>
          </a>
        </div>
        <div className="flex flex-row items-center">
          <p className="text-xs font-semibold text-gray-500">
            {moment(props.award.created_at).fromNow()}{" "}
          </p>
        </div>
      </div>

      <video
        autoPlay
        muted
        loop
        playsInline
        poster="https://ribbon-public-assets.s3.amazonaws.com/temp-image.png"
      >
        <source src={props.award.media} type="video/mp4" />
      </video>

      <div className="py-2">
        <p className="leading-snug text-purpler font-bold">
          {props.award.award_title}
        </p>
        <p className="leading-snug">{props.award.description}</p>
      </div>
      <div>
        <div className="py-2 flex flex-row items-center"></div>
      </div>
    </div>
  );
}
